/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q5Inputs */

const en_sorter_faq_q5 = /** @type {(inputs: Sorter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the sort alphabetical or by character code?`)
};

const ko_sorter_faq_q5 = /** @type {(inputs: Sorter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬은 알파벳순인가요, 문자 코드순인가요?`)
};

const ja_sorter_faq_q5 = /** @type {(inputs: Sorter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えはアルファベット順ですか、文字コード順ですか`)
};

/**
* | output |
* | --- |
* | "Is the sort alphabetical or by character code?" |
*
* @param {Sorter_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q5 = /** @type {((inputs?: Sorter_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q5(inputs)
	if (locale === "ko") return ko_sorter_faq_q5(inputs)
	return ja_sorter_faq_q5(inputs)
});